import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { Menu, X, Compass } from "lucide-react";
import { LOGO } from "@/lib/brand";
import { useAuth } from "@/lib/auth";
import { Button } from "@/components/ui/button";

const links = [
  { to: "/", label: "Home" },
  { to: "/about", label: "About" },
  { to: "/program", label: "The Program" },
  { to: "/daytime", label: "Daytime Play" },
  { to: "/events", label: "Events" },
  { to: "/pricing", label: "Pricing" },
  { to: "/camps", label: "Camps" },
  { to: "/calendar", label: "Expedition Map" },
  { to: "/faq", label: "FAQ" },
  { to: "/support", label: "Support Us" },
];

export function Navbar() {
  const [open, setOpen] = useState(false);
  const { user } = useAuth();
  const nav = useNavigate();

  return (
    <header className="fixed top-0 inset-x-0 z-50 glass border-b border-turquoise/20" data-testid="site-navbar">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 flex items-center justify-between h-16">
        <Link to="/" className="flex items-center gap-2" data-testid="nav-logo-link">
          <img src={LOGO} alt="Adventure Rock Bermuda" className="h-11 w-11 object-contain drop-shadow" />
          <span className="font-display font-extrabold text-white text-sm sm:text-base leading-none tracking-tight">
            ADVENTURE ROCK<span className="block text-turquoise text-[10px] tracking-[0.3em]">BERMUDA</span>
          </span>
        </Link>

        <nav className="hidden md:flex items-center gap-7">
          {links.map((l) => (
            <Link key={l.to} to={l.to} className="text-white/80 hover:text-turquoise transition-colors text-sm font-semibold" data-testid={`nav-${l.label.toLowerCase().replace(/\s/g, "-")}`}>
              {l.label}
            </Link>
          ))}
        </nav>

        <div className="hidden md:flex items-center gap-3">
          {user ? (
            <Button onClick={() => nav("/dashboard")} className="bg-turquoise hover:bg-turquoise/90 text-navy font-bold rounded-full" data-testid="nav-mission-control-btn">
              <Compass className="w-4 h-4 mr-1" /> Mission Control
            </Button>
          ) : (
            <>
              <Button variant="ghost" onClick={() => nav("/login")} className="text-white hover:text-turquoise hover:bg-white/5" data-testid="nav-login-btn">Parent Login</Button>
              <Button onClick={() => nav("/register")} className="bg-gold hover:bg-gold/90 text-navy font-bold rounded-full" data-testid="nav-register-btn">Register</Button>
            </>
          )}
        </div>

        <button className="md:hidden text-white" onClick={() => setOpen(!open)} data-testid="nav-mobile-toggle" aria-label="Menu">
          {open ? <X /> : <Menu />}
        </button>
      </div>

      {open && (
        <div className="md:hidden glass border-t border-turquoise/20 px-4 py-4 space-y-3" data-testid="nav-mobile-menu">
          {links.map((l) => (
            <Link key={l.to} to={l.to} onClick={() => setOpen(false)} className="block text-white/90 font-semibold py-1">{l.label}</Link>
          ))}
          <div className="pt-2 flex flex-col gap-2">
            {user ? (
              <Button onClick={() => { setOpen(false); nav("/dashboard"); }} className="bg-turquoise text-navy font-bold rounded-full">Mission Control</Button>
            ) : (
              <>
                <Button variant="outline" onClick={() => { setOpen(false); nav("/login"); }} className="border-turquoise text-turquoise rounded-full">Parent Login</Button>
                <Button onClick={() => { setOpen(false); nav("/register"); }} className="bg-gold text-navy font-bold rounded-full">Register</Button>
              </>
            )}
          </div>
        </div>
      )}
    </header>
  );
}
